export default {
    ptBR : {
        // COMMONS
        searchOrder : 'Pesquisar pedido',
        searchMenu : 'Pesquisar Menu',
        menu : 'Menu',
        AddNewMenu : 'Novo Menu',
        deliveryOrders : 'Pedidos - Delivery',
        order : 'Pedido',
        orders : 'Pedidos',
        credit_card : 'Cartão de Crédito',
        debit_card : 'Cartão de Débito',
        card_credit : 'Cartão de Crédito',
        card_debit : 'Cartão de Débito',
        money : 'Dinheiro',
        customer : 'Cliente',
        phone : 'Celular',
        address : 'Endereço',
        complement : 'Complemento',
        toDeliver : 'Entregar',
        takeAndGo : 'Retirada no local',
        paymentMethod : 'Forma de pagamento',
        changeFor : 'Troco para',
        totalToPay : 'Total',
        products : 'Produtos',
        observation : 'Obs',
        finalizeOrder : 'Finalizar',
        reprintOrder : 'Reimprimir',
        cancelOrder : 'Cancelar',
        cancel : 'Cancelar',
        save : 'Salvar',
        noOrders : 'Não há pedidos no momento',
        confirmYourIntention : 'Confirme a sua intenção',
        reallyRemoveBill : 'Deseja realmente remover esta conta?',
        yesCancelBill : 'Sim, cancelar conta',
        no : 'Não!',
        errorWhileCancelingBill: 'Houve um erro ao cancelar a conta: ',
        genericErrorMessage : 'Houve um erro ao processar a requisição',
        cancelError : 'Erro ao cancelar',
        deliveryConfigHelp : 'Configurações de Delivery',
        etaExample : 'Ex.: 40 - 45 min',
        eta : 'Tempo Estimado',
        taxes : 'Taxas',
        paymentMethods : 'Formas de Pagamento',
        absolute : 'Absoluto',
        byPerson : 'Por Pessoa',
        percentage : 'Porcentagem',
        taxExample : 'Ex.: Taxa de Entrega',
        close : 'fechar',
        newDelivery: 'Novo pedido - Delivery/Retirada',
        productType : 'Tipo',
        search : 'Procurar',
        editPType : 'Editar Tipo',
        PTypeName : 'Nome do tipo de produto',
        PTypeHelp : 'Entre com um nome para o tipo de produto',
        success : 'Sucesso',
        itemHasBeenRemoved : 'Item removido com sucesso!',
        addOrderTip : 'Adicionar novo pedido',
        reallyRemove : 'Deseja realmente remover?',
        remove : 'Remover',

        // DAYS
        Sun : 'Dom',
        Mon : 'Seg',
        Tue : 'Ter',
        Wed : 'Qua',
        Thu : 'Qui',
        Fri : 'Sex',
        Sat : 'Sáb',

        // MONTH
        Jan : 'Jan',
        Feb : 'Fev',
        Mar : 'Mar',
        Apr : 'Abr',
        May : 'Mai',
        Jun : 'Jun',
        Jul : 'Jul',
        Aug : 'Ago',
        Sep : 'Set',
        Oct : 'Out',
        Nov : 'Nov',
        Dec : 'Dez',

        January   : 'Janeiro',
        February  : 'Fevereiro',
        March     : 'Março',
        April     : 'Abril',
        May       : 'Maio',
        June      : 'Junho',
        July      : 'Julho',
        August    : 'Agosto',
        September : 'Setembro',
        October   : 'Outubro',
        November  : 'Novembro',
        December  : 'Dezembro'
    },

    en : {
        menu : 'Menu',
        searchMenu : 'Search menu',
        searchOrder : 'Search order',
        AddNewMenu : 'New Menu',
        deliveryOrders : 'Orders - Delivery',
        order : 'Order',
        card_credit : 'Credit Card',
        card_debit : 'Debit Card',
        money : 'Money',
        observation : 'Obs',
        finalizeOrder : 'Finalize',
        reprintOrder : 'Reprint',
        cancelOrder : 'Cancel',
        noOrders : 'No Orders',
        confirmYourIntention : 'Confirm your intention',
        reallyRemoveBill : 'Do you really want to remove this bill?',
        yesCancelBill : 'Yes, cancel bill!',
        no : 'No!',
        errorWhileCancelingBill: 'Something goes wrong while canceling the bill: ',
        cancelError : 'Error while canceling',
        orders : 'Orders',
        deliveryConfigHelp : 'Delivery Settings',
        cancel : 'Cancel',
        save : 'Save',
        etaExample : 'eg.: 40 - 45 min',
        eta : 'Estimated Time',
        genericErrorMessage : 'Something goes wrong while trying to process the request: ',
        taxes : 'Fees',
        paymentMethods : 'Payment Methods',
        absolute : 'Absolute',
        byPerson : 'By Person',
        percentage : 'Percentage',
        taxExample : 'eg.: Delivery Fee',
        close : 'Close',
        newDelivery: 'New Order - Delivery',
        productType : 'Type',
        search : 'Search',
        editPType : 'Edit Product',
        PTypeName : 'Product Type Name',
        PTypeHelp : 'Choose a name for product type',
        success : 'Success',
        itemHasBeenRemoved : 'Item has been removed!',
        addOrderTip : 'Add new order',
        reallyRemove : 'Do you really want to remove it?',
        remove : 'Remove',
    }
}